<template>
  <div>
    <div class="is-flex" :class="isMovil ? 'is-justify-center' : ''">
      <button class="button is-link is-outlined" v-on:click="activeMenu">
        Grupos
      </button>
      <div
        v-if="this.activeGroup !== null"
        class="tags has-addons"
        style="margin-left: 10px"
      >
        <span class="tag is-danger">Filtro aplicado</span>
        <a class="tag is-delete" v-on:click="deleteFilter"></a>
      </div>
    </div>
    <nav id="menuFilter" v-if="active" class="panel">
      <div class="panel-heading">
        <div class="is-size-6 is-flex">
          Filtros
          <div
            v-if="groups.length"
            class="tags has-addons"
            style="margin-left: 10px"
          >
            <span class="tag is-link">{{ groups.length }}</span>
          </div>
        </div>
        <button
          class="delete"
          aria-label="delete"
          v-on:click="activeMenu"
        ></button>
      </div>
      <div class="panel-block">
        <p class="control has-icons-left">
          <input
            class="input"
            type="text"
            v-model="search"
            placeholder="Buscar..."
          />
          <span class="icon is-left">
            <i class="material-icons">search</i>
          </span>
        </p>
      </div>
      <div class="panel-body">
        <div v-for="(v, k) in filteredItems" :key="k">
          <a
            class="panel-block"
            :class="{ 'is-active': v.active }"
            @click="select(v.value)"
          >
            <span class="panel-icon">
              <input type="checkbox" :checked="v.active" :id="k" />
            </span>
            {{ v.value }}
          </a>
        </div>
      </div>
      <a v-if="!filteredItems.length" class="panel-block">
        <p>0 resultados</p>
      </a>
      <div class="panel-block">
        <button
          class="button is-link is-outlined is-fullwidth"
          v-on:click="deleteFilter()"
        >
          Eliminar filtros
        </button>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState } from "vuex";

const filterItems = (query, data, activeCurrent) => {
  return data.filter((el) => {
    const texto = el.value;
    if (texto.toLowerCase().indexOf(query.toLowerCase()) > -1) {
      return el;
    }
  });
};
export default {
  data() {
    return {
      search: "",
      active: false,
      activeGroup: null,
    };
  },
  computed: {
    ...mapState(["isOculto", "isMovil"]),
    filteredItems: function() {
      return filterItems(this.search, this.groups, this.activeGroup);
    },
  },
  props: {
    groups: {
      type: Array,
      default() {
        return [];
      },
    },
    gridApi: Object,
  },
  methods: {
    activeMenu() {
      this.active ? (this.active = false) : (this.active = true);
    },
    select(k) {
      // Se busca el index
      this.groups.map((x, i) => {
        if (x.value === k) {
          k = i;
        }
      });

      // Si es el mismo grupo se activa o desactiva
      this.groups[k].active
        ? (this.groups[k].active = false)
        : (this.groups[k].active = true);

      // Se elimina el elemento activo anteriormente
      if (this.activeGroup !== null) {
        this.groups[this.activeGroup].active = false;
        this.activeGroup = null;
      }

      // Si quedo activo este guarda cuál fue el grupo activo
      if (this.groups[k].active) this.activeGroup = k;
    },
    deleteFilter() {
      if (this.activeGroup !== null) {
        this.groups[this.activeGroup].active = false;
        this.activeGroup = null;
        if (this.active) this.activeMenu();
      }
    },
  },
  watch: {
    activeGroup(nv) {
      if (nv !== null)
        return this.gridApi.setQuickFilter(
          `FILTER_${this.groups[nv].value.replace(" ", "")}_GRUPO`
        );

      return this.gridApi.setQuickFilter();
    },
  },
};
</script>
<style>
.panel-heading {
  display: flex;
  justify-content: space-between;
}

#menuFilter {
  margin-top: 15px !important;
  background: white;
  position: absolute;
  z-index: 250;
  max-height: 360px !important;
}

#menuFilter .panel-body {
  max-height: 300px !important;
  overflow: auto;
}

#menuFilter .panel-block {
  background-color: white;
}

#menuFilter .is-active {
  border-left: solid 3px #41aae7;
  color: #363636;
  background: aliceblue;
}

.panel-block .panel-icon .material-icons {
  line-height: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/components/menuFilter.vue